// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusSettingOutlinedSvg from "@fishx/icons-svg/es/asn/RadiusSettingOutlined";
import FishxIcon from '../components/FishxIcon';

var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusSettingOutlinedSvg
  }));
};

RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
export default React.forwardRef(RadiusSettingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadiusSettingOutlined.js
// module id = 3961
// module chunks = 0